import React, { Component } from "react";
import Modal from "react-modal";
import { PopupActionButton } from "../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Alert from "react-s-alert";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../../store/actions/errorActions";
import { superadmin_approved_notapproved } from "../../../../../store/actions/SuperAdminActions/adminPendingActiveDinersAction";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
    position: "relative",
  },
};

export class ApprovedModelPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openApproved: false,
    };
  }

  onApprovedModel = (e) => {
    this.setState({
      openApproved: !this.state.openApproved,
    });
  };

  approvedPendingAction = (e) => {
    const vendorId = this.props.data;
    const token = this.props.auth.user.accessToken;
    const formData = {
      approve: true,
      // have_vendor_submitted_details: true,
    };
    this.props.superadmin_approved_notapproved(
      formData,
      vendorId,
      token,
      this.onActiveVendorAction
    );
  };

  onActiveVendorAction = (e) => {
    Alert.success(`<h4>Restaurant Activate Successfully</h4>`, {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
  };

  render() {
    return (
      <React.Fragment>
        <PopupActionButton
          buttonText="Approve"
          buttonType="button"
          buttonClass="smallsave"
          onClick={this.onApprovedModel}
        />
        <Modal
          isOpen={this.state.openApproved}
          onAfterOpen={this.state.afterOpenModal}
          onRequestClose={this.onApprovedModel}
          style={customStyles}
          className="super_admin_onhold_modal_body"
          contentLabel="Example Modal"
          ariaHideApp={false}
        >
          <div>
            <div className="sa_oh_mb_p-header">
              <h5 className="header_text">Request Approved</h5>
            </div>
            <div>
              <h5 className="font_22_r c_gray mb-4">
                Are you sure you want to Approved
              </h5>
              <div className="d-flex justify-content-between">
                <PopupActionButton
                  buttonText="No"
                  buttonType="button"
                  buttonClass="noButton"
                  onClick={this.onApprovedModel}
                />
                <div className="ml-3">
                  <PopupActionButton
                    buttonText="Yes"
                    buttonType="button"
                    buttonClass="yesButton"
                    onClick={this.approvedPendingAction}
                  />
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

ApprovedModelPopup.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  superadmin_approved_notapproved,
})(withRouter(ApprovedModelPopup));
